import cx from 'classnames';
import {ProgressBar} from '~/CreateFabricInvitation/components/NavHeader/ProgressBar';
import {isInCreateFlowNavABTest} from '~/common/fabric/experiments';

import './ProgressHeader.sass';

interface ProgressHeaderProps {
  navElements: React.ReactNode;
  showProgressBar: boolean;
  currentStepId: number;
  totalSteps: number;
  showPreviewNav: boolean;
}

export const ProgressHeader = ({
  navElements,
  totalSteps,
  currentStepId,
  showPreviewNav,
  showProgressBar,
}: ProgressHeaderProps) => (
  // const showPreviewNav = currentRoute.id === 1 && !isPremium && usedPremiumFeature;
  // const showProgressBar = !showPreviewNav;

  // const totalSteps = 4;
  // const showPreviewNav = true;

  <div className="fabric-header__wrapper">
    <header
      className={cx('fabric-header', {
        frp: totalSteps < 2,
        'premium-preview-header': showPreviewNav,
        'premium-preview-header--named-steps-nav': showPreviewNav && isInCreateFlowNavABTest(),
      })}
    >
      {navElements}
    </header>
    {showProgressBar && <ProgressBar currentStepId={currentStepId} totalSteps={totalSteps} />}
  </div>
);
